<!-- 审核查看 -->

<template>
  <div class="province-3">
    <div class="headBar">
      <span>音像审核制品</span>
      <i class="el-icon-arrow-right"></i>
      <span>音像审核制品</span>
    </div>
    <CommonTab ref="mainTab" :cancelFlag="false" v-if="wSat == 1" pressType="1" :pressDat="resDat" />
    <div v-if="querys.pressState == 2" class="progressTab">
      <div class="headBar">
        <span>审核历史</span>
      </div>
      <el-table :data="tabDat" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="examineName" label="单位" align="center"></el-table-column>
        <el-table-column prop="name" label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row | tansStr("state") }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="批准文号" align="center"></el-table-column>
      </el-table>
    </div>
    <div v-if="querys.pressState == 1" class="subArea">
      <div class="headBar">
        <span>审核意见</span>
      </div>
      <div class="radioBx">
        <el-radio-group v-model="params.status">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="3">退回</el-radio>
        </el-radio-group>
        <el-input
          v-if="params.status == 3"
          v-model="params.message"
          type="textarea"
          :rows="5"
          placeholder="请填写退回原因"></el-input>
      </div>
    </div>
    <div class="subLine">
      <el-button @click="goBack">返回</el-button>
      <el-button v-if="querys.pressState == 1" @click="goExamsave" type="danger">审核</el-button>
    </div>
  </div>
</template>

<script>
import CommonTab from "@/views/components/SPEC/SpecCommonTab";
import { goProvinceExam, successiveHistory } from "@/api/provinceRole/provinceRole";
import { getPressList, sUpdate0 } from "@/api/pressRole/pressRole";
export default {
  components: {
    CommonTab,
  },
  data() {
    return {
      querys: {
        pressType: "",
        pressId: "",
        pressState: 1,
        leadFrom: "",
      },

      wSat: 0,
      resDat: [{}],

      params: {
        publishMaterialIds: [],
        status: 1,
        message: "",
      },
    };
  },

  filters: {
    tansStr: function (dat, code) {
      if (code == "state") {
        if (dat.flowName == "省局") {
          let map = {
            1: "通过",
            3: "退回",
            9: "已审核",
          };

          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          let map = {
            1: "通过",
            2: "暂缓",
            4: "撤销",
            5: "注销",
            9: "已发布",
          };

          return map[dat.status];
        } else if (dat.flowName == "登记") {
          let map = {
            1: "待登记",
            2: "已登记",
          };
          return map[dat.status];
        }
      }
    },
  },

  methods: {
    goExamsave: function () {
      this.params.message = this.params.message || "";
      this.params.message = this.params.message.replace(/\s+/g, "");
      if (this.params.status == 3 && this.params.message.length == 0) {
        this.$message.error("请填写退回意见！");
      } else {
        let msg = "确定已查看完毕，并对该单位核验材料批以通过处理吗？";
        if (this.params.status == 3) {
          msg = "确定已查看完毕，并对该单位核验材料批以退回处理吗？";
        }
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.params.publishMaterialIds.push(this.$refs.mainTab.postPrevs());
            goProvinceExam(this.params).then((response) => {
              this.goBack();
            });
          })
          .catch(() => {});
      }
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },

  created: function () {
    this.querys = {
      pressType: this.$route.query.pressType,
      pressId: this.$route.query.pressId,
      pressState: this.$route.query.pressState,
      leadFrom: this.$route.query.leadFrom,
    };

    getPressList({
      type: this.querys.pressType,
      publishId: this.querys.pressId,
    }).then((response) => {
      let vm = this;
      vm.wSat = 1;
      this.resDat.splice(0, 1, response);
    });
  },
};
</script>

<style lang="scss">
.province-3 {
  padding: 9px;

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;

    span {
      font-size: 14px;
    }
  }

  .radioBx {
    padding: 30px 90px;
  }

  .el-textarea {
    margin-top: 20px;

    textarea {
      resize: none;
      border-radius: 0px;
    }
  }

  .subLine {
    text-align: center;
    margin: 30px 0px;

    .el-button {
      width: 180px;
      margin-top: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// audioTabs.vue?dd4bac2c